import { MAX_CASE_LIST_COLUMNS } from '@bandido/shared/types';

export const columnSelectionKey = (
  userId: string | undefined,
  agencyId: string | number | undefined,
  workflowId: string | undefined,
) => `case-list-columns:${JSON.stringify([userId, agencyId, workflowId])}`;

export function readColumnSelection(key: string): string[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(value)
      ? [...new Set(value.filter((item): item is string => typeof item === 'string' && item.length <= 300))].slice(
          0,
          MAX_CASE_LIST_COLUMNS,
        )
      : [];
  } catch {
    return [];
  }
}
